export const getNodeAtPath = (tree, path) => {
  for (let node of tree) {
    if (node.data.path === path) {
      return node;
    }
    if (node.children && node.children.length > 0) {
      const foundNode = getNodeAtPath(node.children, path);
      if (foundNode) {
        return foundNode;
      }
    }
  }
  return null;
};

export const deleteNodeAtPath = (tree, path) => {
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.data.path === path) {
      tree.splice(i, 1);
      return true;
    }
    if (node.children && node.children.length > 0) {
      const isDeleted = deleteNodeAtPath(node.children, path);
      if (isDeleted) {
        return true;
      }
    }
  }
};

export const getParentPath = path => {
  let parentPath = path.substring(0, path.length - 1); //trim last slash
  parentPath = parentPath.substring(0, parentPath.lastIndexOf("/") + 1); //trim last number
  return parentPath;
};

export const newChildForNode = (node, partnerHierarchyId, numberOfSiblings) => {
  return {
    category: "New item",
    parentDetailId: node?.data?.partnerHierarchyDetailId,
    partnerHierarchyDetailId: null,
    partnerHierarchyId: node?.data?.partnerHierarchyId ?? partnerHierarchyId,
    partnerId: null,
    path: node?.data?.path
      ? node.data.path + (node.children.length + 1).toString() + "/"
      : "/" + (numberOfSiblings + 1).toString() + "/"
  };
};

// Function to recalculate paths for nodes to avoid gaps
export const recalculatePaths = (tree, parentNode) => {
  if (!parentNode || !parentNode.children) {
    // If there's no parent node, recalculate paths for root nodes
    tree.forEach((node, index) => {
      const newPath = "/" + (index + 1).toString() + "/";
      updateNodePath(node, newPath);
    });
  } else {
    // Recalculate paths for the children of the parent node
    parentNode.children.forEach((node, index) => {
      const newPath = parentNode.data.path + (index + 1).toString() + "/";
      updateNodePath(node, newPath);
    });
  }
};

// Function to update a node's path and recursively update its children's paths
export const updateNodePath = (node, newPath) => {
  const oldPath = node.data.path;
  node.data.path = newPath;

  if (node.children && node.children.length > 0) {
    node.children.forEach(child => {
      const relativePath = child.data.path.substring(oldPath.length);
      updateNodePath(child, newPath + relativePath);
    });
  }
};